const dateLeadingZero = (number) => {
  return number.toString().padStart(2, "0");
};

export default dateLeadingZero;
